import { useEffect, useId, useRef, useState } from "react";

import { Icon } from "./Icon.jsx";

export function ResponsiveFilterPanel({
  children,
  description = "Saring daftar sesuai kebutuhan operasional.",
  label = "Filter",
}) {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const titleId = useId();
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    const focusableSelector = [
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])",
    ].join(",");

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        setOpen(false);
        return;
      }

      if (event.key !== "Tab" || !panelRef.current) return;

      const focusable = [...panelRef.current.querySelectorAll(focusableSelector)];
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    window.requestAnimationFrame(() => {
      panelRef.current?.querySelector(focusableSelector)?.focus();
    });

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
      previousFocus?.focus?.();
    };
  }, [open]);

  return (
    <div className="responsive-filter-shell">
      <button
        aria-controls={panelId}
        aria-expanded={open}
        className="secondary-button mobile-filter-trigger"
        onClick={() => setOpen(true)}
        type="button"
      >
        <Icon name="filter" size={16} />
        {label}
      </button>

      {open && (
        <button
          aria-label="Tutup filter"
          className="responsive-filter-backdrop"
          onClick={() => setOpen(false)}
          type="button"
        />
      )}

      <section
        aria-labelledby={titleId}
        aria-modal={open ? "true" : undefined}
        className={`responsive-filter-panel${open ? " is-open" : ""}`}
        id={panelId}
        ref={panelRef}
        role={open ? "dialog" : undefined}
      >
        <header className="responsive-filter-panel__header">
          <div>
            <strong id={titleId}>{label}</strong>
            <span>{description}</span>
          </div>

          <button
            aria-label="Tutup filter"
            className="dialog-close"
            onClick={() => setOpen(false)}
            type="button"
          >
            <Icon name="close" size={18} />
          </button>
        </header>

        <div className="responsive-filter-panel__body">{children}</div>
      </section>
    </div>
  );
}
